export default "__VITE_ASSET__BEuE9FJY__"